// [MCV-1894] Same rule as the API (`INVALID_NPI`): exactly 10 digits, and the
// 10th digit is the Luhn check digit computed over "80840" + the first 9.
export const NPI_ERROR_MESSAGE = 'Enter a valid 10-digit NPI';

export const isValidNpi = (npi: string): boolean => {
  if (!/^\d{10}$/.test(npi)) return false;

  // Luhn over the full "80840" + 10 digit string: every second digit from the
  // right (the check digit is the rightmost, so it is not doubled) is doubled.
  const digits = `80840${npi}`.split('').map(Number);
  let sum = 0;
  for (let i = 0; i < digits.length; i += 1) {
    const fromRight = digits.length - 1 - i;
    let digit = digits[i];
    if (fromRight % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
};

/** Blank is allowed (the NPI is optional); anything typed must be a valid NPI. */
export const npiErrorFor = (npi: string): string => {
  const trimmed = npi.trim();
  return trimmed === '' || isValidNpi(trimmed) ? '' : NPI_ERROR_MESSAGE;
};
